import { Clock, Zap, ShieldCheck, BadgeCheck } from "lucide-react";
import { WHY_US } from "@/data/business";

const ICONS = { Clock, Zap, ShieldCheck, BadgeCheck };

const TECH_IMG =
  "/images/technician-torsion-spring-repair-prosper-tx.webp";

export default function WhyChooseUs() {
  return (
    <section id="why-us" className="relative bg-slate-900 text-white py-20 lg:py-28 overflow-hidden">
      <div className="absolute inset-0 bg-grid-dark opacity-50" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <div className="relative">
              <div className="absolute -inset-3 border border-red-600/30 rounded-sm" />
              <img
                src={TECH_IMG}
                alt="Prosper garage door technician repairing a torsion spring"
                width="1000"
                height="1000"
                loading="lazy"
                className="relative w-full h-[420px] object-cover rounded-sm grayscale-[0.1]"
              />
              <div className="absolute -bottom-5 -right-3 sm:right-6 bg-red-600 text-white px-6 py-4 rounded-sm shadow-xl">
                <p className="font-heading text-3xl font-black leading-none">15+</p>
                <p className="text-xs font-semibold uppercase tracking-wider mt-1">
                  Years Experience
                </p>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-red-600">
              Why Prosper Homeowners Choose Us
            </p>
            <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight">
              Local, Honest, and Always On Call
            </h2>
            <p className="mt-4 text-lg text-slate-300">
              We're your neighbors in Prosper. When your garage door fails, you
              get a real local technician — not a call center — and a fix that
              lasts.
            </p>

            <div className="mt-8 grid sm:grid-cols-2 gap-px bg-white/10 border border-white/10 rounded-sm overflow-hidden">
              {WHY_US.map((w) => {
                const Icon = ICONS[w.icon] || ShieldCheck;
                return (
                  <div
                    key={w.title}
                    className="bg-slate-900/80 p-6"
                    data-testid={`why-card-${w.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  >
                    <Icon className="h-7 w-7 text-red-600" />
                    <h3 className="mt-3 font-heading text-lg font-bold">{w.title}</h3>
                    <p className="mt-1.5 text-sm text-slate-400 leading-relaxed">
                      {w.desc}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
